<template>
  <div id="app">
    <Welcome/>
    <footer>
      <div class="p-4 mt-5 mb-2">
        <Socialfooter/>
      </div>
    </footer>
  </div>
</template>

<script>
import Welcome from '@/components/WelcomeMain.vue'
import Socialfooter from '@/components/Socialfooter.vue'

export default {
  name: 'app',
  components: {
    Welcome,
    Socialfooter
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
